<template>
    <AppLayout :loading="processing">
        <div class="max-w-7xl mx-auto md:px-4 py-4">
            <AdminView
                v-if="showAdminView"
                :products="products"
                :wholesalers="wholesalers"
                :categories="categories"
                :brands="brands"
                :sort-by="sortBy"
                :applied-filters="appliedFilters"
                class="container p-4 mx-auto md:px-1 md:py-4"
                @toggleRightSidebar="toggleRightSidebar"
                @edit="editProduct"
                @delete="deleteProduct"
            />

            <RetailerView
                v-else
                :products="products"
                :wholesalers="wholesalers"
                :categories="categories"
                :brands="brands"
                :applied-filters="appliedFilters"
                :recently-added-products="recentlyAddedProducts"
                :product-featured-images="productFeaturedImages"
                :sort-by="sortBy"
            />
        </div>

        <FullScreenModal
            :is-open="fullModal"
            :component-name="fullModalComponentName"
            :edit-data="editData"
            @closeRightSidebar="toggleRightSidebar"
            @set-processing="processing = $event"
        >
            <template #heading>
                <div class="w-full">
                    <h2 class="text-xl font-semibold text-gray-800 dark:text-white">Product Information</h2>
                </div>
            </template>
        </FullScreenModal>
    </AppLayout>
</template>

<script>
    import AppLayout from '@/Layouts/AppLayout.vue';
    import RetailerView from './RetailerView.vue';
    import AdminView from './AdminView.vue';
    import FullScreenModal from '@/Components/FullScreenModal.vue';

    export default {
        name: 'ProductsIndex',

        components: {
            AppLayout,
            RetailerView,
            AdminView,
            FullScreenModal,
        },

        props: {
            products: {
                type: Object,
                required: true,
            },
            recentlyAddedProducts: {
                type: Array,
                default: () => [],
            },
            productFeaturedImages: {
                type: Array,
                default: () => [],
            },
            wholesalers: {
                type: Array,
                required: true,
            },
            categories: {
                type: Array,
                required: true,
            },
            brands: {
                type: Array,
                required: true,
            },
            appliedFilters: {
                type: Object,
                required: true,
            },
            sortBy: {
                validator: (prop) => typeof prop === 'string' || prop === null,
                required: true,
            },
        },

        data() {
            return {
                processing: false,
                fullModal: false,
                fullModalComponentName: 'CreateProduct',
                editData: null,
            };
        },

        computed: {
            showAdminView() {
                return this.isAdmin || this.isWholesaler;
            },
        },

        watch: {
            fullModal(newVal) {
                if (newVal === false) {
                    this.editData = null;
                }
            },

            products: {
                deep: true,
                handler() {
                    if (this.editData) {
                        this.editData = this.products.data.find((product) => product.id === this.editData.id);
                    }
                },
            },
        },

        methods: {
            editProduct(product) {
                this.editData = product;
                this.toggleRightSidebar();
            },

            deleteProduct(product) {
                this.$inertia.delete(route('products.destroy', product.slug));
            },

            toggleRightSidebar() {
                this.fullModal = !this.fullModal;
            },
        },
    };
</script>
